import { apiRequest } from './api';

const getSlots = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.slots)) return response.slots;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

// The staging tutor-search API's combined date/time filter is unreliable.
// Search by date there, then verify the returned tutors' real slots here.
export async function filterTutorsBySelectedDateTime(
  tutors,
  { selectedDate, selectedTime },
) {
  if (!selectedTime) return tutors;

  const timeMatch = /^(\d{1,2}):(\d{2})$/.exec(selectedTime);
  if (!timeMatch) return [];
  const requestedMinutes = Number(timeMatch[1]) * 60 + Number(timeMatch[2]);
  const requestedAt = selectedDate
    ? new Date(`${selectedDate}T${selectedTime}`)
    : null;
  if (requestedAt && Number.isNaN(requestedAt.getTime())) return [];

  const slotContainsRequestedTime = (slot) => {
    const start = new Date(slot.startTime);
    const end = new Date(slot.endTime);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;

    if (requestedAt) return start <= requestedAt && end > requestedAt;

    // Time-only searches compare the learner's local clock time against all
    // future slots for the selected subject, independently of the date.
    const startMinutes = start.getHours() * 60 + start.getMinutes();
    const endMinutes = end.getHours() * 60 + end.getMinutes();
    if (endMinutes > startMinutes) {
      return startMinutes <= requestedMinutes && requestedMinutes < endMinutes;
    }
    // Safely support availability that crosses midnight.
    return requestedMinutes >= startMinutes || requestedMinutes < endMinutes;
  };

  const checks = await Promise.all(
    tutors.map(async (tutor) => {
      const tutorUserId = tutor?.userId || tutor?.user?.id;
      if (!tutorUserId) return false;

      try {
        const response = await apiRequest(
          `/api/v1/availability/tutor/${tutorUserId}`,
          { method: 'GET' },
        );
        return getSlots(response).some(slotContainsRequestedTime);
      } catch {
        return false;
      }
    }),
  );

  return tutors.filter((_, index) => checks[index]);
}
